import React, { useState, useRef } from "react";
import { Container, Row, Col, Button, Card, CardBody } from 'react-bootstrap';
import { formatDurationAndTime } from "../../Common/appHelper";

const VehicleListViewApi = ({handleAction, vehicleData}) => {

  return (<Container fluid className="vehicle-container">

     <div className="vehicle-list-top">
          <div className="vehicle-list-innerdiv">
            <Card>
              <CardBody>
                <div className="vehicle-list-hd">
                    <h6>Vehicle Activity</h6> <span onClick={() => handleAction('close')}><i className="bx bx-x"></i></span>
                </div>
                <div className="vehicle-list-body">
                  {(vehicleData && (Object.keys(vehicleData).length>0)) ? vehicleData.map((vehicleObj, indx) => {
                    let vehicleTypeCls = '';
                    if(vehicleObj.type === 'Bike') {
                        vehicleTypeCls = 'vehicle-typ1';
                    } else if(vehicleObj.type === 'Car') {
                        vehicleTypeCls = 'vehicle-typ2';
                    } else if(vehicleObj.type === 'Truck') {
                        vehicleTypeCls = 'vehicle-typ3';    
                    }

                    const inTime = vehicleObj.inTime ?? '';
                    const outTime = vehicleObj.outTime ?? '';
                    const durationArr = formatDurationAndTime(inTime,outTime);

                    const fuelValue = (vehicleObj.fuelQuantityLitre) ? `(${vehicleObj.fuelQuantityLitre} L)` : '';
                    const amount = (vehicleObj.amount) ? `₹ ${vehicleObj.amount}` : '';
                    const paymentType = (vehicleObj.paymentType) ? `(${vehicleObj.paymentType})` : '';
                    
                    return (<Row>
                            <Col md={6}>
                                  <div className="vehicle-bsc-info"><span className="vehicle-nmbr-txt">{vehicleObj?.vehicleNo}</span> <span className="sbl-txt">|</span> <span className="vehicle-modl-txt">{vehicleObj?.model}</span> <span className={`vehicle-typ-txt ${vehicleTypeCls}`}>{vehicleObj.type}</span></div>
                                  <p className="user-bsc-info"><span><i className="bx bx-user"></i></span> {vehicleObj?.ownerName}</p>
                            </Col>
                            <Col md={6}>
                                  <div className="vehicle-time-info"><span><i className="bx bx-time"></i></span> {durationArr.minstext} ({durationArr.timestrng})</div>
                                  <p className="fuval-bsc-info">{vehicleObj?.fuel} {fuelValue} | {amount} {paymentType}</p>
                            </Col>
                          </Row>);
                  }) : <div className="no-vehicle-found-main"> 
                            <p className="no-vehicle-found"> No Vehicles Found!... </p>
                  </div>}
                </div>
              </CardBody>
            </Card>
          </div>
     </div>
      
  </Container>);
};

export default VehicleListViewApi;
